import(/* webpackMode: "eager", webpackExports: ["ChangelogPage"] */ "/vercel/path0/app/(main)/changelog/components/ChangelogPage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.3_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
